import { createActions, handleActions } from 'redux-actions';
import selectors from './selectors';

const initialState = {
  hyperionModelData: {},
  isInitializing: false,
  jobId: null,
  modelId: null,
  labels: {},
  manufacturerProducts: {},
  manufacturers: {},
  products: {},
  viewName: null,
  measureTool: null,
};

const INIT = 'DESIGN_PRO/MACHETE/INIT';
const INITIALIZE_MACHETE_EVENTS =
  'DESIGN_PRO/MACHETE/INITIALIZE_MACHETE_EVENTS';
const ENABLE_2OD = 'DESIGN_PRO/MACHETE/ENABLE_2OD';
const DISABLE_2OD = 'DESIGN_PRO/MACHETE/DISABLE_2OD';
const OUTLINE_SELECTED_ELEMENTS =
  'DESIGN_PRO/MACHETE/OUTLINE_SELECTED_ELEMENTS';
const PAN_CAMERA = 'DESIGN_PRO/MACHETE/PAN_CAMERA';
const RECEIVE_HYPERION_MODEL_DATA =
  'DESIGN_PRO/MACHETE/RECEIVE_HYPERION_MODEL_DATA';
const RECEIVE_LABELS = 'DESIGN_PRO/MACHETE/RECEIVE_LABELS';
const RECEIVE_MANUFACTURER_PRODUCTS =
  'DESIGN_PRO/MACHETE/RECEIVE_MANUFACTURER_PRODUCTS';
const RECEIVE_MANUFACTURERS = 'DESIGN_PRO/MACHETE/RECEIVE_MANUFACTURERS';
const RECEIVE_PRODUCTS = 'DESIGN_PRO/MACHETE/RECEIVE_PRODUCTS';
const UPDATE_ELEMENT_ATTRIBUTES =
  'DESIGN_PRO/MACHETE/UPDATE_ELEMENT_ATTRIBUTES';
const UPDATE_FEATURE_ATTRIBUTES =
  'DESIGN_PRO/MACHETE/UPDATE_FEATURE_ATTRIBUTES';
const UPDATE_ELEMENT_WINDOW_GEOMETRY =
  'DESIGN_PRO/MACHETE/UPDATE_ELEMENT_WINDOW_GEOMETRY';
const ZOOM_IN = 'DESIGN_PRO/MACHETE/ZOOM_IN';
const ZOOM_OUT = 'DESIGN_PRO/MACHETE/ZOOM_OUT';
const TOGGLE_MEASURE_TOOL = 'DESIGN_PRO/MACHETE/TOGGLE_MEASURE_TOOL';

const actions = createActions({
  [INIT]: (jobId, modelId, queryString) => ({ jobId, modelId, queryString }),
  [INITIALIZE_MACHETE_EVENTS]: () => null,
  [ENABLE_2OD]: () => null,
  [DISABLE_2OD]: () => null,
  [OUTLINE_SELECTED_ELEMENTS]: () => null,
  [PAN_CAMERA]: (viewName) => ({ viewName }),
  [RECEIVE_HYPERION_MODEL_DATA]: (hyperionModelData) => ({ hyperionModelData }),
  [RECEIVE_LABELS]: (labels) => ({ labels }),
  [RECEIVE_MANUFACTURERS]: (manufacturers) => ({ manufacturers }),
  [RECEIVE_MANUFACTURER_PRODUCTS]: (manufacturerProducts) => ({
    manufacturerProducts,
  }),
  [RECEIVE_PRODUCTS]: (products) => ({ products }),
  [UPDATE_ELEMENT_ATTRIBUTES]: (nodeIds, update) => ({ nodeIds, update }),
  [UPDATE_FEATURE_ATTRIBUTES]: (nodeIds, update) => ({ nodeIds, update }),
  [UPDATE_ELEMENT_WINDOW_GEOMETRY]: (nodeIds, attributes, color) => ({
    nodeIds,
    attributes,
    color,
  }),
  [ZOOM_IN]: () => null,
  [ZOOM_OUT]: () => null,
  [TOGGLE_MEASURE_TOOL]: () => null,
});

const reducer = handleActions(
  {
    [actions.designPro.machete.init]: (state) => ({
      ...state,
      isInitializing: true,
    }),
    [actions.designPro.machete.receiveHyperionModelData]: (state, action) => ({
      ...state,
      hyperionModelData: action.payload.hyperionModelData,
    }),
    [actions.designPro.machete.receiveLabels]: (state, action) => ({
      ...state,
      labels: action.payload.labels,
    }),
    [actions.designPro.machete.receiveManufacturers]: (state, action) => ({
      ...state,
      manufacturers: action.payload.manufacturers,
    }),
    [actions.designPro.machete.receiveManufacturerProducts]: (
      state,
      action,
    ) => ({
      ...state,
      manufacturerProducts: action.payload.manufacturerProducts,
    }),
    [actions.designPro.machete.receiveProducts]: (state, action) => ({
      ...state,
      products: action.payload.products,
    }),
    [actions.designPro.machete.toggleMeasureTool]: (state, action) => ({
      ...state,
    }),
  },
  initialState,
);

export default {
  initialState,
  actions: actions.designPro.machete,
  reducer,
  selectors,
};
